import { FormControl, FormField, FormItem } from "@/components/ui/form"
import { Input } from "@/components/ui/input"
import { useEffect, useMemo } from 'react'
import { useFormContext } from "react-hook-form"
import { GroupedInspections } from '../hooks/useInspectionData'
import { FormLabelWithIndicator } from './form-label-with-indicator'
import { AssetEntity } from "@app.raytd.com/store"

interface AssetDisplayProps {
  inspections: GroupedInspections;
  name: string;
  label: string;
  required: boolean;
}

export function AssetDisplay({ inspections: groupedInspections, name, label, required }: AssetDisplayProps) {
  const { control, watch, setValue } = useFormContext();
  const selectedInspectionId = watch('assessmentId');

  const { assetTitle, assetId } = useMemo(() => {
    console.debug('AssetDisplay: useMemo', { selectedInspectionId, groupedInspections });
    let assetTitle = '(None)';
    let assetId = undefined;

    if (selectedInspectionId) {
      for (const [assetName, inspections] of Object.entries(groupedInspections)) {
        const inspection = inspections.find(i => i.id === selectedInspectionId);
        if (inspection) {
          assetTitle = assetName;
    
          assetId = assetName === 'Unknown' ? null : typeof inspection.asset === 'object' ? (inspection.asset as AssetEntity).id : inspection.asset;
          break;
        }
      }
    }

    return { assetTitle, assetId };
  }, [selectedInspectionId, groupedInspections]);

  // useEffect(() => {
  //   console.debug('AssetDisplay: useEffect', { assetId, name });
  //   if (assetId) {
  //     setValue(name, assetId, {
  //       shouldDirty: true,
  //       shouldTouch: true
  //     });
  //   } else {
  //     setValue(name, undefined, {
  //       shouldDirty: true,
  //       shouldTouch: true
  //     });
  //   }
  // }, [assetId, name, setValue]);

  useEffect(() => {
    const currentValue = watch(name);
    
    // Don't auto-populate if there's already a value (like from existing test data)
    if (currentValue) {
      return;
    }
    
    console.debug('AssetDisplay: useEffect', { assetId, name });
    if (assetId) {
      setValue(name, assetId, {
        shouldDirty: false,
        shouldTouch: false
      });
    }
  }, [assetId, name, setValue, watch]);

  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem>
          <FormLabelWithIndicator
            label={label}
            isValid={!!field.value}
            required={required}
          />
          <FormControl>
            <Input
              value={assetTitle}
              readOnly
              disabled
              className="border-primary/20"
            />
          </FormControl>
        </FormItem>
      )}
    />
  )
}
